import { Routerfile1 } from './router/Routerfile1';

export default function App() {
  return <Routerfile1 />;
}
